function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { uniq } from 'lodash/array';
var Building = /*#__PURE__*/ function() {
    "use strict";
    function Building() {
        _class_call_check(this, Building);
        _define_property(this, "data", buildingData);
        _define_property(this, "$dropdown", document.querySelector('[data-building-year]'));
        _define_property(this, "$buildingRoot", document.querySelector('.building__content'));
        _define_property(this, "$buildingMonths", document.querySelector('.building__months'));
        _define_property(this, "$months", document.querySelectorAll('[data-building-month]'));
    }
    _create_class(Building, [
        {
            key: "handleMonthActive",
            value: function handleMonthActive() {
                var _this = this;
                var timeout = setTimeout(function() {
                    var _monthActive_, _monthActive_1;
                    var months = uniq(window.sliderBuild.slides.filter(function(item) {
                        return item.classList.contains('swiper-slide-visible');
                    }).map(function(item) {
                        return item.dataset.buildingMonthKey;
                    }));
                    _this.$months.forEach(function($item) {
                        $item.classList.toggle('months-line__item_active', months.includes($item.dataset.buildingMonth));
                    });
                    var monthActive = document.querySelectorAll('.months-line__item_active');
                    var monthActiveFirstSizes = (_monthActive_ = monthActive[0]) === null || _monthActive_ === void 0 ? void 0 : _monthActive_.getBoundingClientRect();
                    var monthActiveLastSizes = (_monthActive_1 = monthActive[monthActive.length - 1]) === null || _monthActive_1 === void 0 ? void 0 : _monthActive_1.getBoundingClientRect();
                    var buildingRootSizes = _this.$buildingRoot.getBoundingClientRect();
                    if (monthActiveFirstSizes.x < buildingRootSizes.x) {
                        _this.$buildingMonths.scrollLeft -= buildingRootSizes.x - monthActiveFirstSizes.x;
                    }
                    var monthLength = monthActiveLastSizes.x + monthActiveLastSizes.width;
                    var monthsLength = buildingRootSizes.x + buildingRootSizes.width;
                    if (monthLength > monthsLength) {
                        _this.$buildingMonths.scrollLeft += monthLength - monthsLength;
                    }
                    clearTimeout(timeout);
                }, 250);
            }
        },
        {
            key: "handleChangeYear",
            value: function handleChangeYear(year) {
                var gallery = this.data.find(function(item) {
                    return item.year === year;
                }).gallery;
                var months = uniq(gallery.map(function(item) {
                    return item.month;
                }));
                window.sliderBuild.removeAllSlides();
                window.sliderBuild.appendSlide(gallery.map(function(item) {
                    return '\n						<div class="swiper-slide" data-building-month-key="'.concat(item.month, '">\n							<img src="').concat(item.image, '" alt="" loading="lazy">\n						</div>\n					');
                }));
                window.sliderBuild.slideTo(window.sliderBuild.slides.length - 1, 0);
                this.$months.forEach(function($item) {
                    $item.classList.toggle('months-line__item_disabled', !months.includes($item.dataset.buildingMonth));
                });
                this.handleMonthActive();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var year = this.data[this.data.length - 1].year;
                var $dropdownInput = this.$dropdown.querySelector('[data-dropdown-value]');
                $dropdownInput.value = year;
                this.$dropdown.querySelector('[data-dropdown-label]').innerText = year;
                this.$dropdown.querySelector('.list').innerHTML = this.data.map(function(item, index) {
                    return '<li class="list__item'.concat(index === _this.data.length - 1 ? ' list__item_active' : '', '" data-dropdown-id="').concat(item.year, '">').concat(item.year, "</li>");
                }).join('');
                this.$dropdown.removeAttribute('data-dropdown-init');
                window.dropdown.handleApply();
                setTimeout(function() {
                    _this.handleChangeYear(year);
                }, 500);
                $dropdownInput.addEventListener('input', function() {
                    _this.handleChangeYear($dropdownInput.value);
                });
                window.sliderBuild.on('slideChange', function() {
                    _this.handleMonthActive();
                });
                this.$months.forEach(function($item) {
                    $item.addEventListener('click', function() {
                        var $slideMonth = window.sliderBuild.slides.filter(function(item) {
                            return item.dataset.buildingMonthKey === $item.dataset.buildingMonth;
                        })[0];
                        window.sliderBuild.slideTo(window.sliderBuild.slides.findIndex(function(item) {
                            return item === $slideMonth;
                        }), 250);
                    });
                });
            }
        }
    ]);
    return Building;
}();
export default Building;
